// Error Templates:
export var MessageTemplates;
(function (MessageTemplates) {
    MessageTemplates["IMPROPER_SETUP"] = "{name} object is not set up correctly";
    MessageTemplates["MISSING_FIELDS"] = "{name} object has missing field{s} of type \"{type}\": {fields}";
    MessageTemplates["PASSED_INVALID"] = "Passed in invalid {name} object";
    MessageTemplates["DEPRECATION_WARNING"] = "Event \"{old}\" is deprecated please use event \"{new}\"";
    MessageTemplates["UNABLE_TO_SETUP_INTEGRATION"] = "Unable to setup kollective integration {name} missing from window";
    MessageTemplates["INCORRECT_TYPE"] = "{name} object \"{prop}\" has incorrect type: expected {expected} received {received}";
})(MessageTemplates || (MessageTemplates = {}));
export var ErrorMessages;
(function (ErrorMessages) {
    ErrorMessages["BAD_CONFIG"] = "No valid config found: failing";
    ErrorMessages["BAD_THEOPLAYER"] = "No valid THEOplayer found. Unable to bind Kollective to player";
    ErrorMessages["HLS_CONFLICTING_LOADERS"] = "There is either an Hls#pLoader or Hls#floader set. This will conflict with the kollective integration. Contact Kollective for questions.";
    ErrorMessages["HLS_MISSING_CONFIG"] = "Unable to bind to hls js as no config found";
    ErrorMessages["HLS_MISSING_VERSION"] = "No HLS version provided for HLSjs Config binding as though this were version 0";
    ErrorMessages["INVALID_CONTENT_TOKEN"] = "Invalid contentToken. Could not decode token";
    ErrorMessages["INVALID_JIT_CONFIG"] = "Invalid jitc. Could not decode.";
    ErrorMessages["INVALID_INTEGRATOR_TOKEN"] = "Invalid integratorToken. Could not decode token.";
    ErrorMessages["INVALID_LOAD_OPTIONS"] = "Invalid load options. A contentToken or the combination of integratorToken and jitc is required to start the sdk.";
    ErrorMessages["MISSING_KOLLECTIVE_TOKEN"] = "No kollective session token available";
    ErrorMessages["MISSING_REQUIRED_FIELDS"] = "Missing required information";
    ErrorMessages["NO_CONFIG"] = "No config provided. a config is necessary for playback with the Kollective sdk";
    ErrorMessages["NO_CONTENT_HOST"] = "Unable to continue no host for the kollective content service";
    ErrorMessages["NO_PLAYBACK_MODULE"] = "No playback module selected. reason:";
    ErrorMessages["TECH_API"] = "Unable to set up tech api will be unable to peer";
    ErrorMessages["UNABLE_TO_CONNECT_TO_CONTENT"] = "Unable to connect to kollective content server";
    ErrorMessages["VIBLAST_NO_EVENT_LISTENERS"] = "Unable to set up Viblast integration cannot to set up event listeners";
})(ErrorMessages || (ErrorMessages = {}));
export var PlayerNames;
(function (PlayerNames) {
    PlayerNames["BITMOVIN_PLAYER"] = "Bitmovin";
    PlayerNames["FLOW_PLAYER"] = "Flowplayer";
    PlayerNames["HLS_PLAYER"] = "HLS";
    PlayerNames["SHAKA_PLAYER"] = "Shaka";
    PlayerNames["THEO_PLAYER"] = "THEOplayer";
    PlayerNames["VIDEOJS_PLAYER"] = "VideoJs";
})(PlayerNames || (PlayerNames = {}));
export var DeliveryMode;
(function (DeliveryMode) {
    DeliveryMode["ECDN10"] = "ten_agent";
    DeliveryMode["ECDN11"] = "eleven_agent";
    DeliveryMode["WEBRTC"] = "bbp_agent";
    DeliveryMode["NONE"] = "no_agent";
})(DeliveryMode || (DeliveryMode = {}));
export var PlayType;
(function (PlayType) {
    PlayType["LIVE"] = "LIVE";
    PlayType["VOD"] = "VOD";
    PlayType["UNKNOWN"] = "UNKNOWN";
})(PlayType || (PlayType = {}));
